import React, { useContext } from 'react'
import Box from '@mui/material/Box'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Stack from '@mui/material/Stack'
import SvgIcon from '@mui/material/SvgIcon'
import Typography from '@mui/material/Typography'
import { EPCRContext } from './EPCR'
import { TenantSettingsContext } from '../../../App'
import {
  EPCR_FORM_TYPES,
  FORCES_EVENT_INCIDENT,
  getEnabledRecordTypeValues,
} from './formTypes'

const FormTypeDialog = ({ open, onClose }) => {
  const {
    formValues,
    setFormValues,
    setUploadState,
    setIsDraftDirty,
    selectedEPCRModule,
    setSelectedEPCRModule,
  } = useContext(EPCRContext)
  const orgSettings = useContext(TenantSettingsContext)?.orgConfig?.orgSettings
  const enabled = getEnabledRecordTypeValues(orgSettings)
  // Disabled types stay hidden, except the record's own current type
  const formTypes = EPCR_FORM_TYPES.filter(
    (type) => enabled.includes(type.value) || type.value === formValues.mode,
  )

  const selectType = (value) => {
    if (value !== formValues.mode) {
      setUploadState('pending')
      setFormValues((prev) => ({
        ...prev,
        mode: value,
        incident: {
          ...prev.incident,
          incidentType: FORCES_EVENT_INCIDENT.includes(value)
            ? 'Event'
            : prev.incident?.incidentType,
        },
      }))
      setIsDraftDirty(true)
    }
    if (value === 'Critical Care') setSelectedEPCRModule?.('Live')
    else if (selectedEPCRModule === 'Live') setSelectedEPCRModule?.('Incident')
    onClose()
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 4 } }}
    >
      <DialogTitle>Record Type</DialogTitle>
      <DialogContent>
        <Stack spacing={1.5}>
          <Typography variant="body2" color="text.secondary">
            Choose the type of record to complete. You can change this at any
            time before the record is submitted.
          </Typography>
          {formTypes.map((type) => {
            const isSelected = formValues.mode === type.value
            return (
              <Box
                key={type.value}
                onClick={() => selectType(type.value)}
                sx={{
                  display: 'flex',
                  gap: 1.5,
                  alignItems: 'flex-start',
                  padding: 1.5,
                  borderRadius: 3,
                  cursor: 'pointer',
                  border: '2px solid',
                  borderColor: isSelected ? type.color : 'divider',
                  backgroundColor: isSelected
                    ? (type.bg ?? 'action.selected')
                    : 'transparent',
                  '&:hover': { borderColor: type.color },
                }}
              >
                <SvgIcon
                  component={type.icon}
                  sx={{ color: type.color, mt: 0.25 }}
                />
                <Stack>
                  <Typography fontWeight={700}>{type.label}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {type.description}
                  </Typography>
                </Stack>
              </Box>
            )
          })}
        </Stack>
      </DialogContent>
    </Dialog>
  )
}

export default FormTypeDialog
